import { render } from "./FilterVmsData.vue?vue&type=template&id=28faea2c&scoped=true"
import script from "./FilterVmsData.vue?vue&type=script&lang=js"
export * from "./FilterVmsData.vue?vue&type=script&lang=js"

import "./FilterVmsData.vue?vue&type=style&index=0&id=28faea2c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28faea2c"]])

export default __exports__